module.exports = __webpack_public_path__ + "img/icon.ba9b51c9.svg";